import React from 'react';

import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminTeamMemberCard.css';

const AdminTeamMemberCard = ({
  teamMember,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const teamMemberFields = [
    { label: 'First Name:', value: teamMember.firstName, type: 'text' },
    { label: 'Last Name:', value: teamMember.lastName, type: 'text' },
    { label: 'Job Title:', value: teamMember.jobTitle, type: 'text' },
    { label: 'Description:', value: teamMember.description, type: 'textarea' },
    { label: 'Booking URL:', value: teamMember.janeUrl, type: 'url' },
    { label: 'Cred URL:', value: teamMember.credUrl, type: 'url' },
  ];

  return (
    <>
      <div className='team__list'>
        <div className='admin-team-top-container'>
          <AdminCardOrderField>{teamMember?.order}</AdminCardOrderField>
          <div
            className='admin-team-edit-delete-button-container'
            style={{ marginTop: '0px' }}
          >
            <ContentChangeButton
              iconType='edit'
              onClickHandler={() => onEditClickHandler(teamMember)}
            />
            <ContentChangeButton
              iconType='delete'
              onClickHandler={() => onDeleteClickHandler(teamMember)}
            />
          </div>
        </div>
        <div className='admin-team-content-container'>
          <div className='team-picture-container'>
            <AdminCardImage size='large' img={teamMember.imageUrl} />
          </div>
          <div className='team__group'>
            <div className='team-fields-container'>
              {teamMemberFields.map((field, i) => (
                <AdminCardField key={i} label={field.label} type={field.type}>
                  {field.value}
                </AdminCardField>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminTeamMemberCard;
